module.exports = __webpack_public_path__ + "static/img/confirm_button.c9991139.png";